


















import {Vue, Component, Prop} from "vue-property-decorator";
import {Meeting} from "@api/models/meetings/Meeting";
import {RepositoryFabric} from "../../api/repositories/RepositoryFabric";
import {MeetingRepository} from "../../api/repositories/MeetingRepository";
import MeetingForm from "./MeetingForm.vue";
import {DateTime} from "luxon";
import {dateInOriginalOffset} from "../../common/dateTimeHelper";
import {detectMob} from "../../common/mobileHelper";
import {EventBus} from "@common/EventBus";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";

@Component({
    name: 'EditMeeting',
    components: { MeetingForm }
})
export default class EditMeeting extends AnalyticsMixin {
    @Prop({required: true}) id: string;

    meeting: Meeting|null = null;
    isMounted = false;
    originalDate: DateTime | null = null;

    activated() {
        if (this.isMounted && this.meeting == null) {
            this.init();
        }
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
    }

    async mounted() {
        this.$store.dispatch('showSpinner');
        try {
            await this.init();
            this.isMounted = true;
            this.sendScreenView(`Meeting editing - ${this.originalDate?.toFormat('dd.MM.yyyy H:mm')} ${(this.meeting as Meeting).title}`,
                (this.meeting as Meeting).id,
                'meetings'
            );
        }
        catch (e) {
            this.$store.dispatch('reportException', e);
            this.$store.dispatch('hideSpinner');
        }
        this.$store.dispatch('hideSpinner');
    }

    async init() {
        this.meeting = await (this.$repositories.get(RepositoryFabric.MEETING) as MeetingRepository).find(this.id);
        this.originalDate = dateInOriginalOffset(this.meeting.beginAt || DateTime.local(), this.$store.state.timeZoneOffset);
        if (this.meeting.ownerId != this.userId) {
            this.$router.push({
                name: 'ViewMeeting',
                params: {
                    backend: this.$route.params.backend,
                    id: this.$route.params.id
                }
            })
        }
    }

    beforeSave() {
        this.$store.dispatch('showSpinner');
    }

    saved(meeting: Meeting) {
        this.$store.dispatch('program/updateMeeting', meeting);
        this.$store.dispatch('program/setSavedMeeting', meeting);
        this.$store.dispatch('hideSpinner');
        this.closed();
    }

    saveError(e: any) {
        this.$store.dispatch('reportException', e);
        this.$store.dispatch('hideSpinner');
    }

    closed() {
        this.meeting = null;
        this.$emit('back')
    }

    deleted() {

        this.$store.dispatch('routing/removeByRoute', 'EditMeeting'); //remove from routing module

        setTimeout(() => {
            this.meeting = null;
        }, 300)
    }
}
